var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaxum({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        display: none;\r\n        fill: #fff;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #f94141;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #2c3a4e;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: -0.1,
    y: 0,
    width: 200,
    height: 200
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32,123.1v-26.3h8.3c3.1,0,5.2.1,6.1.4,1.5.4,2.7,1.3,3.7,2.6,1,1.3,1.5,3,1.5,5.1s-.3,3-.9,4.1c-.6,1.1-1.3,2-2.2,2.6-.9.6-1.8,1-2.7,1.2-1.2.3-3,.4-5.4.4h-3.4v9.9h-5.2ZM37.2,101.2v7.5h2.8c2,0,3.4-.1,4.1-.4.7-.3,1.2-.7,1.6-1.3.4-.6.6-1.3.6-2s-.3-1.7-.8-2.4c-.5-.6-1.2-1-2.1-1.2-.6-.1-1.9-.2-3.7-.2h-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84.2,122.9h-6.2l-2.5-6h-11.2l-2.3,6h-6l10.9-26.3h6l11.2,26.3ZM73.8,112.5l-3.9-9.8-3.8,9.8h7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.3,122.7l9.8-13.8-8.9-12.6h6.8l5.8,8.5,5.6-8.5h6.7l-8.9,12.8,9.8,13.6h-7l-6.4-9.1-6.4,9.1h-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124.1,96.3h5.8v14.3c0,2.3,0,3.7.2,4.4.2,1.1.8,1.9,1.8,2.6.9.7,2.2,1,3.8,1s2.9-.3,3.7-.9c.8-.6,1.3-1.4,1.5-2.3.2-.9.3-2.4.3-4.5v-14.6h5.8v13.9c0,3.2-.2,5.4-.5,6.7-.3,1.3-.9,2.4-1.7,3.3-.8.9-2,1.6-3.4,2.1-1.4.5-3.3.8-5.5.8s-4.8-.3-6.2-.9c-1.4-.6-2.5-1.3-3.4-2.3-.8-.9-1.4-1.9-1.6-2.9-.4-1.5-.6-3.7-.6-6.7v-14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M157.9,123.3v-26.7h9.4l5.7,18.2,5.6-18.2h9.4v26.7h-5.8v-21.1l-6.2,21.1h-6.1l-6.2-21.1v21.1h-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.8,99.6s.5-21.5,23.1-23.1v6.9s-14.8,0-15.7,16h-7.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaxum);
export default __webpack_public_path__ + "static/media/paxum.9a6f1bfc15b66dbb7b1ec9e37e095b4d.svg";
export { ForwardRef as ReactComponent };